import { GridLegacy as Grid, Paper, Stack, useTheme } from "@mui/material";
import { getStaffFacingActivityTitle } from "encamp-shared/src/activity/activityDisplayNames";
import { useEffect, useMemo } from "react";
import { Outlet, useMatch, useNavigate } from "react-router-dom";

import { WorkflowActivityStepper } from "../../../../components/WorkflowActivityStepper";
import { useCohortDetails } from "../useCohortDetails";

export function WorkflowLogs() {
  const theme = useTheme();
  const { data } = useCohortDetails();
  const navigate = useNavigate();

  const currentWorkflow = data?.cohort?.currentWorkflow;
  const activities = useMemo(
    () => currentWorkflow?.activities ?? [],
    [currentWorkflow?.activities]
  );

  const currentActivityId = currentWorkflow?.currentActivityId;

  const shouldAutoNavigateToCurrentActivity = useMatch("/staff/cohorts/:cohortId/workflow-logs");

  useEffect(() => {
    if (shouldAutoNavigateToCurrentActivity && currentActivityId) {
      navigate(currentActivityId, { replace: true });
    }
  }, [currentActivityId, navigate, shouldAutoNavigateToCurrentActivity]);

  return (
    <Paper sx={{ paddingTop: theme.spacing(2) }} elevation={0}>
      <Grid container spacing={theme.spacing(2)} minHeight={"500px"}>
        <Grid item xs={4} sx={{ borderRight: `solid 1px ${theme.palette.divider}` }}>
          <Stack direction="column" spacing={2}>
            <WorkflowActivityStepper
              activities={activities}
              currentActivityId={currentActivityId}
              showTooltips={false}
              showChampionIcon={false}
              showSecondaryText={false}
              showEmptyState={true}
              activityTitleFunction={getStaffFacingActivityTitle}
              maxHeight="none"
              replace={false}
              emptyStateMessage="No workflow activities"
            />
          </Stack>
        </Grid>
        <Grid item xs={8}>
          <Outlet />
        </Grid>
      </Grid>
    </Paper>
  );
}
